export const endpoints = {
  availableChannelsPage: '/slack/notification-channel/available-channels/page',
  notificationChannel: '/slack/notification-channel',
} as const;
